import { 
    unitListActionIds
} from './actions/Constants';

const initialState = {
    data: []
}

export default function units(state = initialState, action) {
    switch(action.type) {
        case unitListActionIds.success:
            return Object.assign({}, state, {
                data: action.options.units,
            })
        default:
            return state;
    }
}